// PROTOTYPE-ONLY — remove before production
import React from "react";
import { Outlet, NavLink, Link, useLocation } from "react-router-dom";
import { Home, MapPinned, Layers, Wallet, User, Wifi, Signal, BatteryFull } from "lucide-react";
import PrototypeBadge from "../../components/PrototypeBadge";

const TABS = [
  { path: "/app/scout", label: "Home", icon: Home, end: true },
  { path: "/app/scout/campaigns", label: "Bounties", icon: MapPinned },
  { path: "/app/scout/spots", label: "My Spots", icon: Layers },
  { path: "/app/scout/earnings", label: "Earnings", icon: Wallet },
  { path: "/app/scout/profile", label: "Profile", icon: User },
];

const SWITCHER = [
  { path: "/app/scout", label: "Home" },
  { path: "/app/scout/submit", label: "Submit" },
  { path: "/app/scout/spots", label: "Spots" },
  { path: "/app/scout/earnings", label: "Earnings" },
  { path: "/app/scout/referrals", label: "Referrals" },
  { path: "/app/scout/campaigns", label: "Campaigns" },
];

export default function ScoutShell() {
  const { pathname } = useLocation();
  return (
    <div className="min-h-screen bg-[#080B0D] flex flex-col items-center py-8 px-4">
      <div className="text-center mb-4">
        <div className="flex items-center justify-center gap-2">
          <div className="sb-eyebrow">Mobile App Preview</div>
          <PrototypeBadge />
        </div>
        <h2 className="mt-2 text-[22px] font-black">Scout Mobile App</h2>
      </div>

      {/* Screen switcher pill row — PROTOTYPE-ONLY */}
      <div className="mb-2 flex items-center justify-center">
        <PrototypeBadge />
      </div>
      <div className="mb-6 sb-hscroll flex gap-2 max-w-full">
        {SWITCHER.map((s) => {
          const active = pathname === s.path;
          return (
            <Link
              key={s.path}
              to={s.path}
              data-testid={`switcher-${s.label}`}
              className={`px-4 py-2 rounded-full text-[12px] font-semibold whitespace-nowrap border transition-colors ${
                active
                  ? "bg-[#FFC107] text-[#080B0D] border-[#FFC107]"
                  : "border-[#2A2F34] text-[#A1A1AA] hover:text-white"
              }`}
            >
              {s.label}
            </Link>
          );
        })}
      </div>

      {/* Phone frame */}
      <div className="sb-phone">
        <div className="sb-phone-notch" />
        <div className="sb-phone-inner">
          {/* Status bar */}
          <div className="sb-status-bar">
            <span>9:41</span>
            <span className="flex items-center gap-1.5 text-[#A1A1AA]">
              <Signal size={13} /><Wifi size={13} /><BatteryFull size={15} />
            </span>
          </div>

          {/* Screen content */}
          <div className="flex-1 sb-scroll">
            <Outlet />
          </div>

          {/* Bottom tab bar */}
          <nav className="shrink-0 border-t border-[#2A2F34] bg-[#0B0E11] px-2 pt-2 pb-3 flex items-center justify-between">
            {TABS.map((t) => {
              const Icon = t.icon;
              return (
                <NavLink
                  key={t.path}
                  to={t.path}
                  end={t.end}
                  data-testid={`tab-${t.label}`}
                  className={({ isActive }) =>
                    `flex-1 flex flex-col items-center gap-1 py-1 text-[10px] font-semibold transition-colors ${
                      isActive ? "text-[#FFC107]" : "text-[#A1A1AA]"
                    }`
                  }
                >
                  <Icon size={20} strokeWidth={2} />
                  <span>{t.label}</span>
                </NavLink>
              );
            })}
          </nav>
        </div>
      </div>

      <Link
        to="/"
        className="mt-6 text-[12px] text-[#A1A1AA] hover:text-[#FFC107] underline underline-offset-4 decoration-[#2A2F34]"
      >
        ← Back to marketing site
      </Link>
    </div>
  );
}
